export default {
  common: {
    all: '全て',
    not_set: '未設定',
  },
  login: {
    title: '管理者ログイン',
    username: {
      label: 'ログインID',
      placeholder: 'メールアドレスを入力',
    },
    password: {
      label: 'パスワード',
      placeholder: 'パスワードを入力',
    },
    submit: 'ログイン',
  },
  setting: {
    logout: 'ログアウト',
    db: 'DB指定・管理',
    app_config: 'APP認証',
    db_setting: 'DB設定',
    db_config: 'DBの選択',
    db_setting_contents: '設定画面に戻ります。よろしいでしょうか。',
    url: {
      label: 'URL',
      placeholder: 'URLを入力してください',
    },
    app_id: {
      label: 'APP ID',
      placeholder: 'APP IDを入力してください',
    },
    app_key: {
      label: 'APIキー',
      placeholder: 'APIキーを入力してください',
    },
    db_id: {
      label: 'DB ID',
      placeholder: 'DB IDを入力してください',
    },
    db_key: {
      label: 'DBキー',
      placeholder: 'DBキーを入力してください',
    },

    next: '次へ',
    cluster_db: {
      label: 'Cluster DB',
      placeholder: 'Cluster DBを選択してください',
    },
    back: '戻る',
    cancel: 'キャンセル',
    OK: 'OK',
    finish: '完了',
    no_options: 'オプションなし',
  },
  dashboard: {
    male_female: '男女',
    male: '男性',
    female: '女性',
    age: '年齢',
    child: '子供',
    more: '以上',
    image: '画像',
    id_number: 'ID番号',
    gender: '性別',
    timestamp: '最終時刻',
    stay_time: '滞在時間',
    shots: 'キャプチャー数',
    visits: '訪問数',
    unique: '訪問人数',
  },
  message_error: {
    no_data: '表示するデータはありません。',
    app_config:
      '入力された APP ID、APPキー、DB ID または DBキーが正しくありません。',
    format_url: '正しい形式でURLを入力してください。',
    url_invalid: 'URLが有効ではありません。',
  },
};
